import { Tooltip } from 'antd';
import React from 'react';

import { getTooltipContainer } from '../../TooltipContainer/utils';
import { BadgeContainer, BadgeIcon, BadgeNumber, BadgeText, TooltipContent } from './styled';

export type Props = {
  text: string;
  counter?: number;
  onRemove?: () => void;
  disabled?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: JSX.Element;
  tooltipContent?: React.ReactNode;
};
const Badge = ({
  text,
  counter,
  onRemove,
  disabled = false,
  icon,
  dataTestId = 'badge',
  className,
  tooltipContent,
}: Props): JSX.Element => {
  const onRemoveClick = (): void => {
    if (disabled || !onRemove) return;
    onRemove();
  };

  const badgeContent = (
    <BadgeContainer className={className} data-testid={dataTestId}>
      {icon}
      <BadgeText>{text}</BadgeText>
      {counter && <BadgeNumber>{counter}</BadgeNumber>}
      {onRemove && <BadgeIcon data-testid="removeIcon" $disabled={disabled} onClick={onRemoveClick} />}
    </BadgeContainer>
  );

  if (tooltipContent) {
    return (
      <Tooltip getTooltipContainer={getTooltipContainer} overlayClassName="badgeTooltip" title={tooltipContent}>
        <TooltipContent>{badgeContent}</TooltipContent>
      </Tooltip>
    );
  }

  return badgeContent;
};

export default Badge;
